const navs = [
    {name: "labels.trucks", url: "/fleet-management/trucks/", icon: "truck", role: "admin"},
    {name: "labels.fleet-routes", url: "/fleet-management/routes/", icon: "route", role: "admin"},
];

export default navs;
